import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import delay from 'delay';

import getDataUrlFromFile from 'pages/General/tabs/Theming/_helpers/getDataUrlFromFile';

// Components
import FileDrop from 'components/FileDrop';
import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';

// Style
import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => {
  return {
    removeButton: {
      color: 'red',
    },
    fileDrop: {},
    description: {
      ...theme.typography.caption,
      paddingTop: 0,
    },
    action: {},
  };
};

function ImageField({
  classes,
  imageSrc,
  error,
  onChangeImageUrl,
  onRemove,
  description,
  example,
  maxSize,
}) {
  const showDropper = !imageSrc || !!error;
  const [internalError, setInternalError] = useState('');
  const [file, setFile] = useState(null);

  async function handleNewFile(file) {
    if (!file) {
      setInternalError(
        `Invalid file. Only images less than ${Math.round(maxSize / 1024 ** 2)} MiB are allowed.`,
      );
      await delay(4000);
      setInternalError('');
      return;
    }
    const dataUrl = await getDataUrlFromFile(file);
    onChangeImageUrl(dataUrl);
  }

  const handleSetFile = file => {
    setFile(file);
  };

  return (
    <Fragment>
      <CardContent className={classes.fileDrop}>
        {showDropper ? (
          <FileDrop
            hasError={!!error || !!internalError}
            onFileChange={handleNewFile}
            onSetFile={handleSetFile}
            file={file}
            errorText={error || internalError}
            maxSize={maxSize}
            accept="image/*"
          />
        ) : (
          example
        )}
      </CardContent>
      <CardContent className={classes.description}>{description}</CardContent>
      <CardActions className={classes.action}>
        {!!imageSrc && (
          <Button onClick={onRemove} className={classes.removeButton}>
            Remove
          </Button>
        )}
      </CardActions>
    </Fragment>
  );
}

ImageField.propTypes = {
  classes: PropTypes.object.isRequired,
  imageSrc: PropTypes.string,
  error: PropTypes.string,
  onChangeImageUrl: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  description: PropTypes.node,
  example: PropTypes.node,
  maxSize: PropTypes.number,
};

export default withStyles(styles)(ImageField);
